import {useEffect, useRef, useState} from 'react';
import {Dialog, InputNumber, InputTextarea, SelectButton,} from 'primereact';
import {Button, Col, Container, Form, Row} from 'react-bootstrap';
import useMessage from '../../Hooks/useMessage';
import {useApp, useAuthentication, useConfirm, useTheme} from '../../Hooks';
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import {PagoTarjetaCredito} from '../PagoTarjetaCredito/PagoTarjetaCredito';
import {
    CANCELACION_SERVICIO, CantidadTabletasPOSResturante,
    integracionComernioElectronico,
    integracionesDgii,
    integracionesPanelFirma,
    integracionLinkPago,
    modulosAdi,
    otrasConfig,
    PLANES_ECF,
    PLANES_ECF_GESTION_NEGOCIO, RECARGAR_PERFIL,
    USO_DATOS,
    TERMINAL_TIPO_PT
} from '../../Utils';
import {buscar} from '../../Utils/Buscar';
import EditSection from '../PantallasEdit/EditSection/EditSection';
import ToolTip from '../ToolTip/Tooltip';
import {SvgComponent} from '../SvgComponent/SvgComponent';
import Select from 'react-select'
import {AnimatedIconButton} from '../AnimatedIconButton/AnimatedIconButton';
import { useNavigate } from 'react-router';
import { ACTULIZAR_COMPANIA, OBTENER_USO_DE_DATOS, OBTENER_TOTAL_TERMINALES_ACTIVAS } from "../../../../Seguridad/Scripts/Utils/urls";

const COSTO_LICENCIA = 650;
const COSTO_LICENCIA_PT = 500;
const COSTO_MODULOS_ADICIONALES = 1000;

export function ConfiguracionCuenta({showLoading, hideLoading, setCurrentTab}){
    const navigate = useNavigate();
    const [tipoPago, setTipoPago] = useState(0)
    const [panelFirma, setPanelFirma] = useState([]);
    const [comercioElec, setComercioElec] = useState([]);
    const [intDGII, setIntDGII] = useState([]);
    const [linkPago, setLinkPago] = useState([]);
    const [modulosAdicionales, setModulosAdicionales] = useState([]);
    const [cancelarServicio, setCancelarServicio] = useState([]);
    const [configAdic, setConfigAdi] = useState([]);
    const [compania, setCompania] = useState({});
    const {theme} = useTheme();
    const {usuario, TIENE_PERMISO} = useAuthentication();
    const {Message, Warning} = useMessage();
    const { handleException } = useExceptionHandler();
    const [usoDatos, setUsoDatos] = useState('');
    const [editar, setEditar] = useState(false);
    const [tipoPlan, setTipoPlan] = useState(['1kT']);
    const consultaActualId = useRef();
    const [pagosUnicos, setPagosUnicos] = useState(0)
    const [descuentoCantidadLicencias, setDescuentoCantidadLicencias] = useState(0)
    const pt = {
        incrementButton: {style: {backgroundColor: theme.color1, border: theme.color1, color: "#ffffff", paddingTop: '4px', WebkitBorderTopRightRadius: '6px'}},
        decrementButton: {style: {backgroundColor: theme.color1, border: theme.color1, color: "#ffffff", WebkitBorderBottomRightRadius: '6px'}},
    }
    const { Confirm, Types } = useConfirm();

    const [subTotal, setSubtotal] = useState(0);
    const [totalLicencia, setTotalLicencia] = useState(0);
    const [totalModulos, setTotalModulos] = useState(0);
    const [totalIntegraciones, setTotalIntegraciones] = useState(0);
    const [montDescuentoReferencia, setMontoDescuentoReferencia] = useState(0);
    const [descuentoAnual, setDescuentoAnual] = useState(0);
    const [montoAnual, setMontoAnual] = useState(0);
    const [tipoPlanReferido, setTipoPlanReferido] = useState(1)
    let EsReferido = false;
    const [pagoModalVisible, setPagoModalVisible] = useState(false);

    const [licenciasERP, setLicenciasERP] = useState(0);
    const [licencasCRM, setLicenciasCRM] = useState(0);
    const [licenciasPT, setLicenciasPT] = useState(0);
    const [companiaInicial, setCompaniaInicial] = useState(null);

    const [configInicial, setConfigInicial] = useState({});
    const [newConfig, setNewConfig] = useState({});
    const [pagoExitoso, setPagoExitoso] = useState(false);
    const [value, setValue] = useState(0);
    const [valueCRM, setValueCRM] = useState(0);
    const [valuePT, setValuePT] = useState(0);

    // si es true aumenta sino disminuye
    const [opereacion, setOperacion] = useState(true);
    const [opereacionCRM, setOperacionCRM] = useState(true);
    const [opereacionPT, setOperacionPT] = useState(true);
    const dialogPagoRef = useRef();
    const [pagoAnual, setPagoAnual] = useState(false);
    const [modulosAdicionalesDiff,setModulosAdicionalesDiff] = useState([]);
    const [configuracionAdicionalDiff,setConfiguracionAdicionalDiff] = useState([]);
    const [intDGIIDiff,setIntDGIIDiff] = useState([]);
    const [comercioElecDiff,setComercioElecDiff] = useState([]);
    const [panelFirmaDiff,setPanelFirmaDiff] = useState([]);
    const [enlacePagoDiff,setEnlacePagoDiff] = useState([]);
    const [tipoPlanECFDiff, setTipoPlanECFDiff] = useState([]);
    const [CantidadDispositovsPosRestauranteDiff, setCantidadDispositovsPosRestauranteDiff] = useState([]);
    const [color, setColor] = useState('#495057')
    const [colorCRM, setColorCRM] = useState('#495057')
    const [colorPT, setColorPT] = useState('#495057')

    const [clickPlusERP, setClickPlusERP] = useState(true);
    const [clickPlusCRM, setClickPlusCRM] = useState(true);
    const [clickPlusPT, setClickPlusPT] = useState(true);
    const [clickMinusERP, setClickMinusERP] = useState(false);
    const [clickMinusCRM, setClickMinusCRM] = useState(false);
    const [clickMinusPT, setClickMinusPT] = useState(false);

    const isFirstRun = useRef(true);
    const [totalConfigInicial, setTotalConfigInicial] = useState(0);
    const [tarjetaModalVisible,setTarjetaModalVisbile] = useState(false);
    const dialogTarjetaPagoRef = useRef();
    const { configuration } = useApp();

    const [razonCancelacionModalVisible, setRazonCancelacionModalVisible] = useState(false);
    const dialogRazonCancelacion = useRef();
    const mensajeCancelacionRef = useRef(null);

    const [planesEcf, setPlanesEcf] = useState(PLANES_ECF);
    const [tienePermiso, setTienePermiso] = useState(false);
    const [cantidadDispositivosPosRestaurante, setCantidadDispositovsPosRestaurante] = useState([])
    
    const [modulosEliminados, setModulosEliminados] = useState([]);
    useEffect(() => {
        setPlanesEcf(configuration?.Vendor === 'claro' ? PLANES_ECF_GESTION_NEGOCIO : PLANES_ECF);
    },[configuration])

    useEffect(() => {
        if(usuario){
            let compania = usuario.Compania;
            setCompania(compania);
            setCompaniaInicial(compania);
            let panelFirmaValue = null;
            if(compania.Configuracion.UsaModuloVisaNet){
                panelFirmaValue = 2
            }else if (compania.Configuracion.UsaModuloCardNet){
                panelFirmaValue = 1
            }else if (compania.Configuracion.UsaModuloAzul){
                panelFirmaValue = 3
            }
            setPanelFirma([panelFirmaValue])

            let comercioElecValue = [];
            if(compania.UsaShopify){
                comercioElecValue.push(2)
            }
            if (compania.UsaWooCommerce){
                comercioElecValue.push(1)
            }
            if (compania.UsaMiniHotel){
                comercioElecValue.push(3)
            }
            setComercioElec(comercioElecValue);

            let intDGIIValue = null
            if(compania.UsaFacturacionElectronica){
                compania._usaFacturacionElectronica = true;
                intDGIIValue = 1
            }else if (compania.Configuracion.UsaImpresoraFiscal){
                intDGIIValue = 2
            }
            setIntDGII([intDGIIValue])

            let tipoPlanECF = null;
            if(intDGIIValue === 1){
                let planValue = planesEcf.find((plan) => plan.label === compania.TipoPlanECF)?.value;
                compania._TipoPlanEcf = planValue;
                tipoPlanECF = planValue;
                setTipoPlan([tipoPlanECF])
            }

            let linkPagoValue = null
            if(compania.UsaEnlacePago){
                linkPagoValue = 1
            }
            setLinkPago([linkPagoValue]);

            let modulosAdicionalesValue = []
            if(compania.UsaNomina){
                modulosAdicionalesValue.push(1)
            }
            if (compania.Configuracion.UsaConsulta){
                modulosAdicionalesValue.push(2)
            }
            if (compania.UsaFactoring){
                modulosAdicionalesValue.push(3)
            }
            if(compania.UsaRestaurante){
                modulosAdicionalesValue.push(4)
            }
            if (compania.UsaPrestamo) {
                modulosAdicionalesValue.push(5)
            }
            setModulosAdicionales(modulosAdicionalesValue);

            let otrasConfigValue = []
            if(compania.UsaCaja){
                otrasConfigValue.push(1)
            }
            if (compania.UsaCentro){
                otrasConfigValue.push(2)
            }
            let cantidadDispAdicPosRestaurante = null;
            if(compania.UsaRestaurante){
                let plan = CantidadTabletasPOSResturante.find((plan) => plan.name === compania.CantidadDispositivosAdicionalesRestaurante);
                compania.CantidadDispositivosAdicionalesRestaurante = plan?.name;
                cantidadDispAdicPosRestaurante = plan?.value;
                setCantidadDispositovsPosRestaurante([cantidadDispAdicPosRestaurante])
            }
            setConfigAdi(otrasConfigValue);
            setLicenciasERP(compania.CantidadUsuarios ?? 0)
            setLicenciasCRM(compania.CantidadUsuariosCRM ?? 0);
            setLicenciasPT(compania.CantidadUsuariosPT ?? 0);

            let configInicial = {
                licenciasERP: compania.CantidadUsuarios,
                licencasCRM: compania.CantidadUsuariosCRM,
                licenciasPT: compania.CantidadUsuariosPT ?? 0,
                otrasConfig: otrasConfigValue,
                modulosAdicionales: modulosAdicionalesValue,
                linkPago: [linkPagoValue],
                intDGII: [intDGIIValue],
                comercioElec: comercioElecValue,
                panelFirma: [panelFirmaValue],
                tipoPlanECF: [tipoPlanECF],
                CantidadDispositivosPosRestaurante: [cantidadDispAdicPosRestaurante]
            }
            calculateTotal(pagoAnual,false);
            setConfigInicial(configInicial)
            setNewConfig(configInicial);
            setTienePermiso(TIENE_PERMISO("Citrus.Seguridad.MiCuenta.Visualizar") || compania?.Configuracion?.EsCompaniaPrueba);
        }
    }, [usuario,editar]);
    useEffect(() => {
        setTimeout(() => {
            const element2 = document.querySelectorAll('.p-button.p-component');
            if (element2.length > 0) {
                element2.forEach((map) => {
                    if(map.nodeName !== 'BUTTON'){
                        map.style.backgroundColor = 'unset'
                    }
                })
            }
            const element = document.querySelectorAll('.p-button.p-component.p-highlight');
            if (element.length > 0) {
                element.forEach((map) => {
                    map.style.backgroundColor = theme.color1T
                })
            }
        }, pagoModalVisible ? 50 : 0)
    }, [configAdic, compania, tipoPago, pagoModalVisible]);
    useEffect(() => {
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = OBTENER_USO_DE_DATOS
        buscar(url, { }).then((data) => {
            if (consultaId === consultaActualId.current) {
                setUsoDatos(data.totalUsoDatos)
            }
        }).catch((error) => {
            handleException(error);
        }).finally(() => {
            //hideLoading();
        });
    }, []);
    const Editar = () => {
        if(!tienePermiso){
            Warning({message: 'Usuario no tiene este permiso'})
            return;
        }
        if(!compania.cliente && !compania.Configuracion.EsCompaniaPrueba){
            Warning({message: 'Esta Compañía está mal configurada. Contacte con el Administrador para continuar el proceso.'})
            return;
        }
        setEditar(!editar);
        setCompania(companiaInicial);
    }
    const getStatus = (mod, newConfigArray, initialConfigArray) => {
        if (newConfigArray?.includes(mod.value) && !initialConfigArray?.includes(mod.value)) {
            return { value: mod.value, status: 'A' };
        } else if (!newConfigArray?.includes(mod.value) && initialConfigArray?.includes(mod.value)) {
            return { value: mod.value, status: 'E' };
        } else if (newConfigArray?.includes(mod.value) && initialConfigArray?.includes(mod.value)) {
            return { value: mod.value, status: 'N' };
        }
        return null;
    };
    const processConfigs = (modules, newConfigArray, initialConfigArray) => {
        return modules
            .map(mod => getStatus(mod, newConfigArray, initialConfigArray))
            .filter(Boolean);
    };

    useEffect(() => {
        setModulosAdicionalesDiff(processConfigs(modulosAdi, newConfig?.modulosAdicionales, configInicial?.modulosAdicionales));
        setIntDGIIDiff(processConfigs(integracionesDgii, newConfig?.intDGII, configInicial?.intDGII));
        setComercioElecDiff(processConfigs(integracionComernioElectronico, newConfig?.comercioElec, configInicial?.comercioElec));
        setPanelFirmaDiff(processConfigs(integracionesPanelFirma, newConfig?.panelFirma, configInicial?.panelFirma));
        setEnlacePagoDiff(processConfigs(integracionLinkPago, newConfig?.linkPago, configInicial?.linkPago));
        setConfiguracionAdicionalDiff(processConfigs(otrasConfig, newConfig?.otrasConfig, configInicial?.otrasConfig));
        setTipoPlanECFDiff(processConfigs(planesEcf, newConfig?.tipoPlanECF, configInicial?.tipoPlanECF));
        setCantidadDispositovsPosRestauranteDiff(processConfigs(CantidadTabletasPOSResturante, newConfig?.CantidadDispositivosPosRestaurante, configInicial?.CantidadDispositivosPosRestaurante));
    }, [newConfig]);
    useEffect(() => {
        if (licenciasERP + value > compania?.CantidadUsuarios) {
            setColor('green')
        }else if (licenciasERP - value < compania?.CantidadUsuarios) {
            setColor('red')
        }else {
            setColor('#495057')
        }
    }, [licenciasERP]);
    useEffect(() => {
        if (licencasCRM + valueCRM > compania?.CantidadUsuariosCRM) {
            setColorCRM('green')
        }else if (licencasCRM - valueCRM < compania?.CantidadUsuariosCRM) {
            setColorCRM('red')
        }else {
            setColorCRM('#495057')
        }
    }, [licencasCRM]);

    useEffect(() => {
        let usuariosPTActuales = compania?.CantidadUsuariosPT ?? 0;
        if (licenciasPT + valuePT > usuariosPTActuales) {
            setColorPT('green')
        } else if (licenciasPT - valuePT < usuariosPTActuales) {
            setColorPT('red')
        } else {
            setColorPT('#495057')
        }
    }, [licenciasPT]);

    function recargarPerfil(){
        const obtenerDatos = () => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;

            const url =
                RECARGAR_PERFIL
            buscar(url, {}).then((data) => {
                if (consultaId === consultaActualId.current) {
                    window.location.reload();
                }
            });
        };
        obtenerDatos();
    }

    function validarLicencias() {
        const obtenerDatos = () => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;

            const url = OBTENER_TOTAL_TERMINALES_ACTIVAS
            buscar(url, {tipo: TERMINAL_TIPO_PT}).then((data) => {
                if (consultaId === consultaActualId.current) {
                    if (newConfig.licenciasPT < data.TotalTerminalesActivas  ) {
                        Confirm({
                            type: Types.TYPE_DEFAULT,
                            title: `Terminales excedentes`,
                            textBody: `Tiene menos licencias que dispositivos vinculados.\nDebe desvincular los dispositivos que exceden las licencias.`,
                            onConfirm: () => { window.open('/TerminalPos/terminal_pos_list.aspx', '_blank'); },
                            onCancel: () => {},
                            confirmBtnText: "Desvincular",
                            cancelBtnText: "Cancelar",
                        });
                    }
                    else {
                        calculateTotal(pagoAnual, false);
                        setPagoModalVisible(true);
                    }
                }
            });
        };
        obtenerDatos();
    }

    function ActualizarCompania() {

        setPagoModalVisible(false);
        setRazonCancelacionModalVisible(false)
        showLoading();
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = ACTULIZAR_COMPANIA
        let cantidadDispRestaurante = undefined;
        if ((compania?._usaRestaurante ?? compania?.UsaRestaurante ?? false)){
            const selectedModulo = CantidadTabletasPOSResturante.find(
                (mod) => mod.value === compania?.CantidadDispositivosPosRestaurante
            );
            cantidadDispRestaurante = selectedModulo?.name ?? undefined;
        }
        buscar(url, { newCompania: {
                _usaFacturacionElectronica: (compania?._usaFacturacionElectronica ?? compania.UsaFacturacionElectronica) ?? false,
                _UsaVisaNet: (compania?._UsaVisaNet ?? compania.Configuracion.UsaModuloVisaNet) ?? false,
                _UsaAzul: (compania?._UsaAzul ?? compania.Configuracion.UsaModuloAzul) ?? false,
                _UsaImpresoraFiscal: (compania?._UsaImpresoraFiscal ?? compania.Configuracion.UsaImpresoraFiscal) ?? false,
                _UsaShopify: (compania?._UsaShopify ?? compania.UsaShopify) ?? false,
                _UsaWooCommerce: (compania?._UsaWooCommerce ?? compania.UsaWooCommerce) ?? false,
                _UsaCardNetEnLinea: (compania?._UsaCardNetEnLinea ?? compania.UsaEnlacePago) ?? false,
                _UsaCardNet: (compania?._UsaCardNet ?? compania.Configuracion.UsaModuloCardNet) ?? false,
                _UsaFactoring: (compania?._UsaFactoring ?? compania.UsaFactoring) ?? false,
                _UsaConsulta: (compania?._UsaConsulta ?? compania.Configuracion.UsaConsulta) ?? false,
                _UsaNomina: (compania?._UsaNomina ?? compania.UsaNomina) ?? false,
                _UsaCentro: (compania?._UsaCentro ?? compania.UsaCentro) ?? false,
                _UsaCaja: (compania?._UsaCaja ?? compania.UsaCaja ?? false),
                _TipoPlanEcf: (compania?._TipoPlanEcf ?? compania.TipoPlanECF) ?? "",
                licenciasCRM : licencasCRM,
                licenciasERP : licenciasERP,
                licenciasPT : licenciasPT,
                CantidadLicenciasERP: value,
                CantidadLicenciasCRM: valueCRM,
                CantidadLicenciasPT: valuePT,
                CancelarERP: compania?.CancelarERP ?? false,
                CancelarCRM: compania?.CancelarCRM ?? false,
                RazonCancelacion: mensajeCancelacionRef?.current?.value ?? "",
                _UsaMiniHotel: (compania?._UsaMiniHotel ?? compania.UsaMiniHotel ?? false),
                _usaRestaurante: (compania?._usaRestaurante ?? compania?.UsaRestaurante ?? false),
                _usaPrestamo: (compania?._usaPrestamo ?? compania?.UsaPrestamo ?? false),
                _CantidadDispositivosAdicionalesRestaurante: (cantidadDispRestaurante ?? compania.CantidadDispositivosAdicionalesRestaurante)
            }}).then((data) => {
            if (consultaId === consultaActualId.current) {
                hideLoading();
                if(data.redirect){
                    navigate('/Public/pantalla_cancelacion_exitosa.aspx');
                }else{
                    Message({message: data.message})
                    setTimeout(() => {
                        recargarPerfil()
                    },1000)
                }
            }
        }).catch((error) => {
            handleException(error);
            if(error.Mensaje === 'Para Cancelar su Servicio debe saldar el Balance Pendiente. Ante cualquier duda o inquietud comuníquese con nosotros al (809) 548-8274 o al correo pagos@citrus.com.do'){
                setCurrentTab('log')
            }
        }).finally(() => {
            hideLoading();
        });
    }

    const PagoBody = () => {
        return (
            <div className='bootstrapiso'>
                <Row>
                    <Col>
                        <EditSection title='Configuracion anterior'>
                            <div className="list-group" style={{marginBottom:'15px'}}>
                                {compania?.CantidadUsuarios > 0 && (
                                    <a
                                        href="#"
                                        className="list-group-item list-group-item-action"
                                    >
                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                x{compania?.CantidadUsuarios} Licencias ERP
                                            </h5>

                                            <small>RD$ {
                                                // eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo
                                                (COSTO_LICENCIA * compania?.CantidadUsuarios)
                                            }</small>
                                        </div>
                                    </a>
                                )}
                                {compania?.CantidadUsuariosPT > 0 && (
                                    <a href="#"  className="list-group-item list-group-item-action">
                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                                x{compania?.CantidadUsuariosPT} Licencias PT
                                            </h5>
                                            <small>RD$ {
                                                // eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA_PT * compania?.CantidadUsuariosPT)
                                            }</small>
                                        </div>
                                    </a>
                                )}
                                {compania?.CantidadUsuariosCRM > 0 && (
                                    <a
                                        href="#"
                                        className="list-group-item list-group-item-action"
                                    >
                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                x{compania?.CantidadUsuariosCRM} Licencias CRM
                                            </h5>
                                            <small>RD$ {
                                                // eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * compania?.CantidadUsuariosCRM)
                                            }</small>
                                        </div>
                                    </a>
                                )}
                                {configInicial?.modulosAdicionales?.map((modulo) => {
                                    const selectedModulo = modulosAdi.find(
                                        (mod) => mod.value === modulo
                                    );
                                    if (selectedModulo) {
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        Modulo {selectedModulo.name}
                                                    </h5>
                                                    <small>RD$ {
                                                        // eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}
                                                    </small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {configInicial?.intDGII?.map((modulo) => {
                                    const selectedModulo = integracionesDgii.find(
                                        (mod) => mod.value === modulo
                                    );
                                    if (selectedModulo && selectedModulo?.value === 2) {
                                        return (
                                            <>
                                                <a
                                                    href="#"
                                                    className="list-group-item list-group-item-action"
                                                    key={selectedModulo.value}
                                                >
                                                    <div className="d-flex w-100 justify-content-between">
                                                        <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                            Integracion {selectedModulo.name}{selectedModulo.value === 1 && (<small className='text-muted'>Pago unico</small>)}
                                                        </h5>
                                                        <small>RD$ {
                                                            // eslint-disable-next-line no-undef
                                                            Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)
                                                        }
                                                        </small>
                                                    </div>
                                                </a>
                                            </>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {configInicial?.tipoPlanECF?.map((tipo) => {
                                    const selectedModulo = planesEcf.find(
                                        (mod) => mod.value === tipo
                                    );
                                    if (selectedModulo && configInicial?.intDGII[0] === 1) {
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        Plan de {selectedModulo.label} <small className='text-muted'>Facturacion Electronica</small>
                                                    </h5>
                                                    <small>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(selectedModulo.precio)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {configInicial?.comercioElec?.map((modulo) => {
                                    const selectedModulo =
                                        integracionComernioElectronico.find(
                                            (mod) => mod.value === modulo
                                        );
                                    if (selectedModulo) {
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        Integracion {selectedModulo.name}
                                                    </h5>
                                                    <small>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {configInicial?.panelFirma?.map((modulo) => {
                                    const selectedModulo = integracionesPanelFirma.find(
                                        (mod) => mod.value === modulo
                                    );
                                    if (selectedModulo) {
                                        return (
                                            <>
                                                <a
                                                    href="#"
                                                    className="list-group-item list-group-item-action"
                                                    key={selectedModulo.value}
                                                >
                                                    <div className="d-flex w-100 justify-content-between">
                                                        <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                            Panel de firma {selectedModulo.name}
                                                        </h5>
                                                        <small>RD$ {// eslint-disable-next-line no-undef
                                                            Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                    </div>
                                                </a>
                                            </>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {configInicial?.linkPago?.map((modulo) => {
                                    const selectedModulo = integracionLinkPago.find(
                                        (mod) => mod.value === modulo
                                    );
                                    if (selectedModulo) {
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        Integracion {selectedModulo.name}
                                                    </h5>
                                                    <small>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                        </EditSection>
                    </Col>
                    <Col>
                        <EditSection title='Nueva configuracion'>
                            <div className="list-group" >
                                {licenciasERP > 0 && (
                                    <a
                                        href="#"
                                        className="list-group-item list-group-item-action"
                                        style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                    >
                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                {licenciasERP + value > compania?.CantidadUsuarios ? (
                                                    `+${value}  x${licenciasERP} Licencias ERP`
                                                ) : licenciasERP - value < compania?.CantidadUsuarios ? (
                                                    `-${value} x${licenciasERP} Licencias ERP`
                                                ) : (
                                                    `x${licenciasERP} Licencias ERP`
                                                )}
                                            </h5>
                                            <small style={{color: color !== 'green' && color !== 'red' ? '#999' : color}}>RD$ {// eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * licenciasERP)}</small>
                                        </div>
                                    </a>
                                )}
                                {(licenciasPT > 0 || (compania?.CantidadUsuariosPT ?? 0) > 0) && (
                                    <a
                                        href="#"
                                        className="list-group-item list-group-item-action"
                                        style={{ color: colorPT, background: colorPT === 'green' ? 'rgb(0,255,0, 0.1)' : colorPT === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent" }}
                                    >

                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                                {licenciasPT + valuePT > (compania?.CantidadUsuariosPT ?? 0) ? (
                                                    `+${valuePT}  x${licenciasPT} Licencias PT`
                                                ) : licenciasPT - valuePT < (compania?.CantidadUsuariosPT ?? 0) ? (
                                                    `-${valuePT} x${licenciasPT} Licencias PT`
                                                ) : (
                                                    `x${licenciasPT} Licencias PT`
                                                )}
                                            </h5>
                                            <small style={{ color: colorPT !== 'green' && colorPT !== 'red' ? '#999' : colorPT }}>RD$ {// eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA_PT * licenciasPT)}</small>
                                        </div>
                                    </a>
                                )}
                                {licencasCRM > 0 && (
                                    <a
                                        href="#"
                                        className="list-group-item list-group-item-action"
                                        style={{color: colorCRM, background: colorCRM === 'green' ? 'rgb(0,255,0, 0.1)' : colorCRM === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                    >

                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                {licencasCRM + valueCRM > compania?.CantidadUsuariosCRM ? (
                                                    `+${valueCRM}  x${licencasCRM} Licencias CRM`
                                                ) : licencasCRM - valueCRM < compania?.CantidadUsuariosCRM ? (
                                                    `-${valueCRM} x${licencasCRM} Licencias CRM`
                                                ) : (
                                                    `x${licencasCRM} Licencias CRM`
                                                )}
                                            </h5>
                                            <small style={{color: colorCRM !== 'green' && colorCRM !== 'red' ? '#999' : colorCRM}}>RD$ {// eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * licencasCRM)}</small>
                                        </div>
                                    </a>
                                )}
                                {modulosAdicionalesDiff?.map((modulo) => {
                                    const selectedModulo = modulosAdi.find(
                                        (mod) => mod.value === modulo.value
                                    );
                                    if (selectedModulo) {
                                        let color;
                                        if(modulo.status === 'N'){
                                            color = '#495057'
                                        }else if(modulo.status === 'E'){
                                            color = 'red'
                                        }else if(modulo.status === 'A'){
                                            color = 'green'
                                        }
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                                style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        {color === 'green' ? (
                                                            `+ Modulo ${selectedModulo.name}`
                                                        ) : color === 'red' ? (
                                                            `- Modulo ${selectedModulo.name}`
                                                        ) : (
                                                            `Modulo ${selectedModulo.name}`
                                                        )}
                                                        {selectedModulo.value === 4 && (                                                    
                                                            <>
                                                            <small className='text-muted'>• Pt camarero: 2 tabletas </small>
                                                            <small className='text-muted'>• Servicio de Impresion: 1 estacion</small>
                                                            </>
                                                        )}
                                                    </h5>
                                                    <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {CantidadDispositovsPosRestauranteDiff.map((tipo) => {
                                    const selectedModulo = CantidadTabletasPOSResturante.find(
                                        (mod) => mod.value === tipo.value
                                    );
                                    if (selectedModulo) {
                                        let color;
                                        if(tipo.status === 'N'){
                                            color = '#495057'
                                        }else if(tipo.status === 'E'){
                                            color = 'red'
                                        }else if(tipo.status === 'A'){
                                            color = 'green'
                                        }
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                                style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        {selectedModulo.name} <small className='text-muted'>Dispositivos Adicionales</small>
                                                    </h5>
                                                    <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(selectedModulo.precio)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                
                                {intDGIIDiff?.map((modulo) => {
                                    const selectedModulo = integracionesDgii.find(
                                        (mod) => mod.value === modulo.value
                                    );
                                    if (selectedModulo) {
                                        let color;
                                        if(modulo.status === 'N'){
                                            color = '#495057'
                                        }else if(modulo.status === 'E'){
                                            color = 'red'
                                        }else if(modulo.status === 'A'){
                                            color = 'green'
                                        }
                                        return (
                                            <>
                                                {selectedModulo.value === 1 && (modulo.status === 'E' || modulo.status === 'N') ? (
                                                    <></>
                                                ) : (
                                                    <a
                                                        href="#"
                                                        className="list-group-item list-group-item-action"
                                                        key={selectedModulo.value}
                                                        style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                                    >
                                                        <div className="d-flex w-100 justify-content-between">
                                                            <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                                {color === 'green' ? (
                                                                    <>+ Integracion {selectedModulo.name} {selectedModulo.value === 1 && (<small style={{color:'green'}} className='text-muted'>Pago unico</small>)}</>
                                                                ) : (color === 'red' && selectedModulo.value === 1) ? (
                                                                    <>- Integracion {selectedModulo.name} {selectedModulo.value === 1 && (<small style={{color:'green'}} className='text-muted'>Pago unico</small>)}</>
                                                                ) : (
                                                                    <>Integracion {selectedModulo.name} {selectedModulo.value === 1 && (<small style={{color:'green'}} className='text-muted'>Pago unico</small>)}</>
                                                                )}
                                                            </h5>
                                                            {selectedModulo.value === 1 ? (
                                                                <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                                    Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES * 10)}</small>
                                                            ): (
                                                                <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                                    Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                            )}
                                                        </div>
                                                    </a>
                                                )}
                                                {(selectedModulo.value === 2 && modulo.status === 'A') && (
                                                    <a
                                                        href="#"
                                                        className="list-group-item list-group-item-action"
                                                        key={selectedModulo.value}
                                                        style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                                    >
                                                        <div className="d-flex w-100 justify-content-between">
                                                            <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column', color: 'green'}}>
                                                                + Instalacion remota {selectedModulo.name} <small className='text-muted'>Pago unico</small>
                                                            </h5>
                                                            <small style={{color: 'green'}}>RD${// eslint-disable-next-line no-undef
                                                                Citrus.Convert.toCurrencyNoSimbolo(4000)}</small>
                                                        </div>
                                                    </a>
                                                )}
                                            </>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {tipoPlanECFDiff.map((tipo) => {
                                    const selectedModulo = planesEcf.find(
                                        (mod) => mod.value === tipo.value
                                    );
                                    if (selectedModulo) {
                                        let color;
                                        if(tipo.status === 'N'){
                                            color = '#495057'
                                        }else if(tipo.status === 'E'){
                                            color = 'red'
                                        }else if(tipo.status === 'A'){
                                            color = 'green'
                                        }
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                                style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        Plan de {selectedModulo.label} <small className='text-muted'>Facturacion Electronica</small>
                                                    </h5>
                                                    <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(selectedModulo.precio)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {comercioElecDiff?.map((modulo) => {
                                    const selectedModulo =
                                        integracionComernioElectronico.find(
                                            (mod) => mod.value === modulo.value
                                        );
                                    if (selectedModulo) {
                                        let color;
                                        if(modulo.status === 'N'){
                                            color = '#495057'
                                        }else if(modulo.status === 'E'){
                                            color = 'red'
                                        }else if(modulo.status === 'A'){
                                            color = 'green'
                                        }
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                                style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        {color === 'green' ? (
                                                            `+ Integracion ${selectedModulo.name}`
                                                        ) : color === 'red' ? (
                                                            `- Integracion ${selectedModulo.name}`
                                                        ) : (
                                                            `Integracion ${selectedModulo.name}`
                                                        )}
                                                    </h5>
                                                    <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {panelFirmaDiff?.map((modulo) => {
                                    const selectedModulo = integracionesPanelFirma.find(
                                        (mod) => mod.value === modulo.value
                                    );
                                    if (selectedModulo) {
                                        let color;
                                        if(modulo.status === 'N'){
                                            color = '#495057'
                                        }else if(modulo.status === 'E'){
                                            color = 'red'
                                        }else if(modulo.status === 'A'){
                                            color = 'green'
                                        }
                                        return (
                                            <>
                                                <a
                                                    href="#"
                                                    className="list-group-item list-group-item-action"
                                                    key={selectedModulo.value}
                                                    style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                                >
                                                    <div className="d-flex w-100 justify-content-between">
                                                        <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                            {color === 'green' ? (
                                                                `+ Panel de firma ${selectedModulo.name}`
                                                            ) : color === 'red' ? (
                                                                `- Panel de firma ${selectedModulo.name}`
                                                            ) : (
                                                                `Panel de firma ${selectedModulo.name}`
                                                            )}
                                                        </h5>
                                                        <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                            Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                    </div>
                                                </a>
                                                {modulo.status === 'A' && (
                                                    <a
                                                        href="#"
                                                        className="list-group-item list-group-item-action"
                                                        key={selectedModulo.value}
                                                        style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                                    >
                                                        <div className="d-flex w-100 justify-content-between">
                                                            <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column', color: 'green'}}>
                                                                + Integracion remota {selectedModulo.name} <small className='text-muted'>Pago unico</small>
                                                            </h5>
                                                            <small style={{color: 'green'}}>RD$ {// eslint-disable-next-line no-undef
                                                                Citrus.Convert.toCurrencyNoSimbolo(4000)}</small>
                                                        </div>
                                                    </a>
                                                )}
                                            </>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                {enlacePagoDiff?.map((modulo) => {
                                    const selectedModulo = integracionLinkPago.find(
                                        (mod) => mod.value === modulo.value
                                    );
                                    if (selectedModulo) {
                                        let color;
                                        if(modulo.status === 'N'){
                                            color = '#495057'
                                        }else if(modulo.status === 'E'){
                                            color = 'red'
                                        }else if(modulo.status === 'A'){
                                            color = 'green'
                                        }
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                                style={{color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent"}}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{width: '70%', display:'flex',flexDirection:'column'}}>
                                                        {color === 'green' ? (
                                                            `+ Integracion ${selectedModulo.name}`
                                                        ) : color === 'red' ? (
                                                            `- Integracion ${selectedModulo.name}`
                                                        ) : (
                                                            `Integracion ${selectedModulo.name}`
                                                        )}
                                                    </h5>
                                                    <small style={{color: color === 'green' || color === 'red' ? color : '#999'}}>RD$ {// eslint-disable-next-line no-undef
                                                        Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                            <div className='d-flex'>
                                <div style={{fontSize: 'smaller'}}>
                                    <SvgComponent
                                        iconName="circulo"
                                        style={{
                                            marginLeft: "3px",
                                            marginBottom: "1px",
                                        }}
                                        fill={'#00ff00'}
                                        width="20px"
                                        height="20px"
                                    />
                                    Servicio agregado
                                </div>
                                <div style={{fontSize: 'smaller'}}>
                                    <SvgComponent
                                        iconName="circulo"
                                        style={{
                                            marginLeft: "3px",
                                            marginBottom: "1px",
                                        }}
                                        fill={'#FF0000'}
                                        width="20px"
                                        height="20px"
                                    />
                                    Servicio eliminado
                                </div>
                            </div>
                        </EditSection>
                    </Col>
                </Row>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <div
                        className="card mb-4 shadow-sm"
                        style={{ width: '100%' }}
                    >
                        <div className="card-header">
                            <h4 className="my-0 font-weight-normal">
                                Monto a pagar
                            </h4>
                        </div>
                        <div className="card-body">
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    Subtotal:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    {pagoAnual ? (
                                        `RD$${// eslint-disable-next-line no-undef
                                            Citrus.Convert.toCurrencyNoSimbolo(
                                                (montoAnual + pagosUnicos + Math.abs(descuentoAnual)) ?? 0
                                            )}`
                                    ) : (
                                        ((compania?.CantidadUsuarios ?? 0) + value) > 20 ? (

                                            `RD$${// eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(
                                                    (subTotal + pagosUnicos + Math.abs(descuentoCantidadLicencias)) ?? 0
                                                )}`
                                        ):(
                                            `RD$${// eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(
                                                    (subTotal + pagosUnicos) ?? 0
                                                )}`
                                        )
                                    )}
                                </h1>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    Descuento:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    {pagoAnual ? (
                                        `RD$${// eslint-disable-next-line no-undef
                                            Citrus.Convert.toCurrencyNoSimbolo(
                                                Math.abs(descuentoAnual) ?? 0
                                            )}`
                                    ) : (
                                        ((compania?.CantidadUsuarios ?? 0) + value) > 20 ? (

                                            `RD$${// eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(
                                                    Math.abs(descuentoCantidadLicencias ?? 0)
                                                )}`
                                        ):(
                                            `RD$${// eslint-disable-next-line no-undef
                                                Citrus.Convert.toCurrencyNoSimbolo(
                                                    0
                                                )}`
                                        )
                                    )}
                                </h1>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    Impuestos:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    {pagoAnual
                                        ? ` RD$${// eslint-disable-next-line no-undef
                                            Citrus.Convert.toCurrencyNoSimbolo(
                                                (pagosUnicos * 0.18)
                                            )}`
                                        : ` RD$${// eslint-disable-next-line no-undef
                                            Citrus.Convert.toCurrencyNoSimbolo(
                                                (pagosUnicos * 0.18)
                                            )}`}
                                </h1>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    Total:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{fontSize: '1.5rem'}}>
                                    {pagoAnual
                                        ? ` RD$${// eslint-disable-next-line no-undef
                                            Citrus.Convert.toCurrencyNoSimbolo(
                                                montoAnual + pagosUnicos + (pagosUnicos * 0.18)
                                            )}`
                                        : ` RD$${// eslint-disable-next-line no-undef
                                            Citrus.Convert.toCurrencyNoSimbolo(
                                                subTotal + pagosUnicos + (pagosUnicos * 0.18)
                                            )}`}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex align-items-center mb-4 flex-column'>
                    <SelectButton
                        pt={{
                            button: {style: {width: '150px',borderRadius: '6px',border: `1px solid ${theme.color1}`, color:theme.color1,padding: '0.75rem 0.75rem'}}
                        }}
                        className="d-flex"
                        value={tipoPago}
                        options={[{name: 'Tarjeta', value: 0},]}
                        onChange={(e) => setTipoPago(e.value)}
                        optionLabel='name'
                        id="tipoPago"
                        disabled
                    />
                    <div style={{fontSize: 'smaller'}}>
                        <SvgComponent
                            iconName="circulo"
                            style={{
                                marginLeft: "3px",
                                marginBottom: "1px",
                            }}
                            fill={'#0033ff'}
                            width="20px"
                            height="20px"
                        />
                        Solo se permiten pagos con tarjeta de credito
                    </div>
                </div>
                <Form.Group>
                    <Button type="button" onClick={() => {
                        var modulosEliminadosTemp = [];

                        intDGIIDiff?.map((modulo) => {
                            if(modulo.status === 'E'){
                                const selectedModulo = integracionesDgii.find(
                                    (mod) => mod.value === modulo.value
                                );
                                modulosEliminadosTemp.push(selectedModulo.name)                          
                            }
                        })
                        comercioElecDiff?.map((modulo) => {
                            if(modulo.status === 'E'){
                                const selectedModulo = integracionComernioElectronico.find(
                                    (mod) => mod.value === modulo.value
                                );
                                modulosEliminadosTemp.push(selectedModulo.name)
                            }
                        })
                        enlacePagoDiff?.map((modulo) => {
                            if(modulo.status === 'E'){
                                const selectedModulo = integracionComernioElectronico.find(
                                    (mod) => mod.value === modulo.value
                                );
                                modulosEliminadosTemp.push(selectedModulo.name)
                            }
                        })
                        panelFirmaDiff?.map((modulo) => {
                            if(modulo.status === 'E'){
                                const selectedModulo = integracionesPanelFirma.find(
                                    (mod) => mod.value === modulo.value
                                );
                                modulosEliminadosTemp.push(selectedModulo.name)
                            }
                        })
                        modulosAdicionalesDiff?.map((modulo) => {
                            if(modulo.status === 'E'){
                                const selectedModulo = modulosAdi.find(
                                    (mod) => mod.value === modulo.value
                                );
                                modulosEliminadosTemp.push(selectedModulo.name)
                            }
                        })
                        
                        if(modulosEliminadosTemp.length > 0){
                            setModulosEliminados(modulosEliminadosTemp)
                            setRazonCancelacionModalVisible(true)
                        }
                        else 
                        {
                            if((subTotal + pagosUnicos + (pagosUnicos * 0.18)) > 0){
                                setTarjetaModalVisbile(true)
                            }else {
                                ActualizarCompania()
                            }   
                        }
                    }} className="btn btn-success btn-lg form-control">Aceptar</Button>
                </Form.Group>
            </div>
        )
    }

    useEffect(() => {
        let licencias = opereacion ? (compania?.CantidadUsuarios ?? 0)  + value : (compania?.CantidadUsuarios ?? 0)  - value;
        if(!opereacion && licencias <= 0){
            Warning({message: 'La cantidad de licencias no puede ser 0, si desea eliminar la subscripción para este servicio, marque la opcion cancelar Citrus ERP.'})
        }
        setLicenciasERP(licencias < 0 ? 0 : licencias);
        if(opereacion){
            setClickPlusERP(true);
            setClickMinusERP(false);
        }else{
            setClickPlusERP(false);
            setClickMinusERP(true);
        }
    }, [opereacion]);
    useEffect(() => {
        let licencias = opereacionCRM ? (compania?.CantidadUsuariosCRM ?? 0)  + valueCRM : (compania?.CantidadUsuariosCRM ?? 0)  - valueCRM;
        if(!opereacionCRM && licencias <= 0){
            Warning({message: 'La cantidad de licencias no puede ser 0, si desea eliminar la subscripción para este servicio, marque la opcion cancelar Citrus CRM.'})
        }
        setLicenciasCRM(licencias < 0 ? 0 : licencias);
        if(opereacionCRM){
            setClickPlusCRM(true);
            setClickMinusCRM(false);
        }else{
            setClickPlusCRM(false);
            setClickMinusCRM(true);
        }
    }, [opereacionCRM]);

    useEffect(() => {
        let licencias = opereacionPT ? (compania?.CantidadUsuariosPT ?? 0) + valuePT : (compania?.CantidadUsuariosPT ?? 0) - valuePT;
        setLicenciasPT(licencias < 0 ? 0 : licencias);
        if (opereacionPT) {
            setClickPlusPT(true);
            setClickMinusPT(false);
        } else {
            setClickPlusPT(false);
            setClickMinusPT(true);
        }
    }, [opereacionPT]);

    function calculateTotal(pagoAnual, esReferido) {

        let descuentoMultiplier = 1;
        let descuentoAnualMultiplier = pagoAnual ? (esReferido ? 0.8625 : 0.9) : 1;
        let costoLicenciaUnitario = COSTO_LICENCIA;

        let totalLicenciasErp = costoLicenciaUnitario * (opereacion ? (value ?? 0) : 0);
        let totalLicenciasPT = COSTO_LICENCIA_PT * (opereacionPT ? (valuePT ?? 0) : 0);
        const costoLicencias = (costoLicenciaUnitario * (opereacionCRM ? (valueCRM ?? 0) : 0)) + totalLicenciasErp + totalLicenciasPT;
        setTotalLicencia(costoLicencias);

        const costoModulo = COSTO_MODULOS_ADICIONALES;

        let modAdiDiff = 0;
        modulosAdicionalesDiff?.map((modulo) => {
            if(modulo.status === "A") {
                modAdiDiff += 1;
            }
        })
        let modulosDiff = 0;
        intDGIIDiff?.map((modulo) => {
            if(modulo.status === 'A' && modulo.value === 2){
                modulosDiff += 1
            }
        })
        comercioElecDiff?.map((modulo) => {
            if(modulo.status === 'A') {
                modulosDiff += 1
            }
        })
        panelFirmaDiff?.map((modulo) => {
            if(modulo.status === 'A') {
                modulosDiff += 1
            }
        })
        enlacePagoDiff?.map((modulo) => {
            if(modulo.status === 'A') {
                modulosDiff += 1
            }
        })
        const costoModulos = costoModulo * (modAdiDiff);
        let costoIntegraciones = costoModulo * modulosDiff ;
        let pagosUnicos = ((panelFirma[0] !== null && panelFirma.length > 0 && configInicial?.panelFirma[0] === null ? 4000 : 0) +
            (intDGII[0] !== null && intDGII.length > 0 && intDGII[0] === 1 && configInicial?.intDGII[0] !== 1 ? 10000 : 0) +
            (intDGII[0] !== null && intDGII.length > 0 && intDGII[0] === 2 && configInicial?.intDGII[0] !== 2 ? 4000 : 0) )
        setPagosUnicos(pagosUnicos);
        descuentoMultiplier = pagoAnual && esReferido ? 1 : (esReferido ? 0.75 : 1);

        const planSeleccionado = tipoPlanECFDiff.map((plan) => planesEcf.find((planes) => plan.value === planes.value && plan.status === 'A')).filter(Boolean)[0]
        costoIntegraciones += (tipoPlan[0] !== null && tipoPlan.length > 0 && compania?._usaFacturacionElectronica ? planSeleccionado?.precio ?? 0 : 0)
        if(modulosAdicionalesDiff.find((mod) => mod.value === 4)){
            const cantDispSelecionado =  CantidadDispositovsPosRestauranteDiff.map((plan) => CantidadTabletasPOSResturante.find((planes) => plan.value === planes.value && plan.status === 'A')).filter(Boolean)[0]
            costoIntegraciones += (cantDispSelecionado?.precio ?? 0)   
        }
        let subtotal = costoLicencias + costoModulos + costoIntegraciones;
        let montoDescuentoPorCantidadLicencias = subtotal * 0.2;
        if(((compania?.CantidadUsuarios ?? 0) + value) > 20){
            setDescuentoCantidadLicencias(montoDescuentoPorCantidadLicencias);
            subtotal = subtotal * 0.8;
        }

        if(tipoPlanReferido === 1){
            // 25% de descuentos primero 3 meses
            const subTotalConDescuento = subtotal * descuentoMultiplier;
            const descuentoAnual = (subTotalConDescuento * descuentoAnualMultiplier) - subTotalConDescuento;

            setTotalModulos(costoModulos);
            setTotalIntegraciones(costoIntegraciones);
            setSubtotal(subTotalConDescuento);
            setMontoAnual(subTotalConDescuento * descuentoAnualMultiplier * 12);
            setDescuentoAnual(descuentoAnual * 12);

            if (isFirstRun.current && subTotalConDescuento !== 0) {
                setTotalConfigInicial(subTotalConDescuento)
                isFirstRun.current = false;
            }

            if (esReferido && !pagoAnual) {
                setMontoDescuentoReferencia(subtotal - subTotalConDescuento);
            }
        }
        else {
            // primer mes gratis
            setSubtotal(0)
            const montoAnual = (subtotal * 12) - subtotal;
            if (esReferido && !pagoAnual) {
                setMontoDescuentoReferencia(subtotal);
            }
            setMontoAnual(montoAnual * 0.9 );
            setDescuentoAnual( montoAnual - (montoAnual * 0.9) + subtotal);
            setTotalModulos(costoModulos);
            setTotalIntegraciones(costoIntegraciones);
        }

    }
    useEffect(() => {
        calculateTotal(pagoAnual, false);
    }, [
        pagoAnual,
    ]);
    const onHidePagoModal = () => {
        setPagoModalVisible(false);
    }
    useEffect(() => {
        if(pagoExitoso){
            setPagoExitoso(false)
            setPagoModalVisible(false);
            setTarjetaModalVisbile(false);
            ActualizarCompania();
        }
    }, [pagoExitoso]);

    const RazonCancelacionBody = () => {
        
        var textoCancelacion = "Por favor, indíquenos el motivo de su cancelación. Su opinión es muy importante para nosotros y nos ayuda a mejorar nuestros servicios.";
        
        if (modulosEliminados.length > 0) {
            textoCancelacion = `Su opinión es muy importante para nosotros y nos ayuda a mejorar nuestros servicios. Por favor, indíquenos el motivo de su cancelaciónde los siguientes modulos.  \n\n Modulos eliminados: ${modulosEliminados.join(', ')}`
        }
        
        return (
            <div className='bootstrapiso' style={{display: 'flex', flexDirection: 'column'}}>
                <h3>{textoCancelacion}</h3>
                <InputTextarea ref={mensajeCancelacionRef} rows={5} cols={30}/>
                <div className="d-flex justify-content-center mt-3">
                    <Button className="btn btn-lg form-control" type="button" style={{height:'auto',backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1}} onClick={() => {
                        if(mensajeCancelacionRef.current === null || mensajeCancelacionRef.current.value === '') {
                            Warning({message: 'Para proceder tiene que escribir su razon de cancelación'});
                        } else if (mensajeCancelacionRef.current.value.length < 5) {
                            Warning({message: 'El mensaje es muy corto'});
                        } else {
                            if((subTotal + pagosUnicos + (pagosUnicos * 0.18)) > 0){
                                setTarjetaModalVisbile(true)
                                setRazonCancelacionModalVisible(false)
                            }else {
                                ActualizarCompania()
                            }
                        }
                    }}>Cancelar servicio</Button>
                </div>
            </div>
        )
    }

    return (
        <>
            {!compania?.Configuracion?.EsCompaniaPrueba && (
                <Container>
                    <Dialog ref={dialogPagoRef} header='Detalles' visible={pagoModalVisible} style={{ width: '70vw' }} breakpoints={{'1280': '70vw', '960px': '85vw', '641px': '450px','400px': '350px' }} onHide={onHidePagoModal}
                            pt={{
                                root: {style: {backgroundColor: '#fff'}},
                                header:{style: {backgroundColor: theme.color1, color: '#fff', borderRadius: '6px', margin:'10px', padding: '10px'}},
                                closeButtonIcon:{style: {color: '#fff'}}
                            }}
                    >
                        {PagoBody()}
                    </Dialog >
                    <Dialog ref={dialogTarjetaPagoRef} header='Pago con tarjeta de credito' visible={tarjetaModalVisible} style={{ width: '50vw' }} breakpoints={{'1280': '70vw', '960px': '85vw', '641px': '450px','400px': '350px' }} onHide={() => setTarjetaModalVisbile(false)}
                            pt={{
                                root: {style: {backgroundColor: '#fff'}},
                                header:{style: {backgroundColor: theme.color1, color: '#fff', borderRadius: '6px', margin:'10px', padding: '10px'}},
                                closeButtonIcon:{style: {color: '#fff'}}
                            }}>
                        {PagoTarjetaCredito(setPagoExitoso,subTotal + pagosUnicos + (pagosUnicos * 0.18), (subTotal + pagosUnicos + Math.abs(montDescuentoReferencia)) ?? 0, pagosUnicos * 0.18, showLoading, hideLoading)}
                    </Dialog>
                    <Dialog ref={dialogRazonCancelacion} header='Razón de Cancelación' visible={razonCancelacionModalVisible} style={{ width: '50vw' }} breakpoints={{'1280': '70vw', '960px': '85vw', '641px': '450px','400px': '350px' }} onHide={() => setRazonCancelacionModalVisible(false)}
                            pt={{
                                root: {style: {backgroundColor: '#fff'}},
                                header:{style: {backgroundColor: theme.color1, color: '#fff', borderRadius: '6px', margin:'10px', padding: '10px'}},
                                closeButtonIcon:{style: {color: '#fff'}}
                            }}
                    >
                        {RazonCancelacionBody()}
                    </Dialog>
                    {tienePermiso && (
                        <div className='d-flex justify-content-end' style={{paddingBottom: '15px'}}>
                            <ToolTip message="Editar">
                                <div onClick={Editar}>
                                    <SvgComponent
                                        iconName="pencil"
                                        style={{
                                            cursor: "pointer",
                                            marginLeft: "3px",
                                            marginBottom: "1px",
                                        }}
                                        width="22px"
                                        height="22px"
                                    />
                                </div>
                            </ToolTip>
                        </div>
                    )}
                    <div className='d-flex justify-content-around mb-3'>
                        <div className='d-flex flex-column align-items-center'>
                            <h2 className='text-muted'>Licencias ERP</h2>
                            {editar ? (
                                <>
                                    <div className='d-flex align-items-center mb-3' style={{ gap: '20px' }}>
                                        <p style={{ marginBottom: '0', fontSize: '1.3rem' }}>Actuales: <span style={{ fontWeight: 'bold' }}>{compania?.CantidadUsuarios ?? 0}</span> </p>
                                        <div>
                                            <AnimatedIconButton
                                                size="20px"
                                                height="10"
                                                width="10"
                                                iconName={"plus-crm"}
                                                message={`Aumentar`}
                                                onClick={() => {
                                                    setOperacion(true)
                                                }}
                                                clicked={clickPlusERP}
                                                disabled={false}
                                            />
                                            <AnimatedIconButton
                                                size="20px"
                                                height="10"
                                                width="10"
                                                iconName={"minus-crm"}
                                                message={`Disminuir`}
                                                onClick={() => {
                                                    setOperacion(false)
                                                }}
                                                clicked={clickMinusERP}
                                                disabled={false}
                                            />
                                        </div>
                                        <InputNumber pt={pt} value={value} size={1} min={0} max={opereacion ? 100 : compania?.CantidadUsuarios ?? 0} onValueChange={(e) => {
                                            if(!opereacion && compania?.CantidadUsuarios - e.value <= 0){
                                                Warning({message: 'La cantidad de licencias no puede ser 0, si desea eliminar la subscripción para este servicio, marque la opcion cancelar Citrus ERP.'})
                                                setValue(0)
                                            }else {
                                                setValue(e.value)
                                                let cantLicencias = opereacion ? (compania?.CantidadUsuarios ?? 0)  + e.value : (compania?.CantidadUsuarios ?? 0)  - e.value
                                                setLicenciasERP(cantLicencias)
                                                setNewConfig({
                                                    ...newConfig,
                                                    licenciasERP: cantLicencias
                                                })
                                            }
                                        }} showButtons style={{ width: '3rem' }}
                                                     decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
                                    </div>
                                    <h4>Total de Licencias: {licenciasERP} </h4>
                                </>
                            ) : (
                                <>
                                    <h4>{compania?.CantidadUsuarios ?? 0}</h4>
                                </>
                            )}
                        </div>
                        <div className='d-flex flex-column align-items-center'>
                            <h2 className='text-muted'>Licencias PT</h2>
                            {editar ? (
                                <>
                                    <div className='d-flex align-items-center mb-3' style={{ gap: '20px' }}>
                                        <p style={{ marginBottom: '0', fontSize: '1.3rem' }}>Actuales: <span style={{ fontWeight: 'bold' }}>{compania?.CantidadUsuariosPT ?? 0}</span> </p>
                                        <div>
                                            <AnimatedIconButton
                                                size="20px"
                                                height="10"
                                                width="10"
                                                iconName={"plus-crm"}
                                                message={`Aumentar`}
                                                onClick={() => {
                                                    setOperacionPT(true)
                                                }}
                                                clicked={clickPlusPT}
                                                disabled={false}
                                            />
                                            <AnimatedIconButton
                                                size="20px"
                                                height="10"
                                                width="10"
                                                iconName={"minus-crm"}
                                                message={`Disminuir`}
                                                onClick={() => {
                                                    setOperacionPT(false)
                                                }}
                                                clicked={clickMinusPT}
                                                disabled={false}
                                            />
                                        </div>
                                        <InputNumber pt={pt} value={valuePT} size={1} min={0} max={opereacionPT ? 100 : compania?.CantidadUsuariosPT ?? 0} onValueChange={(e) => {
                                            if (!opereacionPT && compania?.CantidadUsuariosPT - e.value <= 0) {
                                                setValuePT(0)
                                            } else {
                                                setValuePT(e.value)
                                                let cantLicencias = opereacionPT ? (compania?.CantidadUsuariosPT ?? 0) + e.value : (compania?.CantidadUsuariosPT ?? 0) - e.value
                                                setLicenciasPT(cantLicencias)
                                                setNewConfig({
                                                    ...newConfig,
                                                    licenciasPT: cantLicencias
                                                })

                                            }
                                        }} showButtons style={{ width: '3rem' }}
                                            decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
                                    </div>
                                    <h4>Total de Licencias: {licenciasPT} </h4>
                                </>
                            ) : (
                                <>
                                    <h4>{compania?.CantidadUsuariosPT ?? 0}</h4>
                                </>
                            )}
                        </div>
                        <div className='d-flex flex-column align-items-center'>
                            <h2 className='text-muted'>Licencias CRM</h2>
                            {editar ? (
                                <>
                                    <div className='d-flex align-items-center mb-3' style={{ gap: '20px' }}>
                                        <p style={{ marginBottom: '0', fontSize: '1.3rem' }}>Actuales: <span style={{ fontWeight: "bold" }}>{compania?.CantidadUsuariosCRM ?? 0}</span> </p>
                                        <div>
                                            <AnimatedIconButton
                                                size="20px"
                                                height="10"
                                                width="10"
                                                iconName={"plus-crm"}
                                                message={`Aumentar`}
                                                onClick={() => setOperacionCRM(true)}
                                                disabled={false}
                                                clicked={clickPlusCRM}
                                            />
                                            <AnimatedIconButton
                                                size="20px"
                                                height="10"
                                                width="10"
                                                iconName={"minus-crm"}
                                                message={`Disminuir`}
                                                onClick={() => setOperacionCRM(false)}
                                                clicked={clickMinusCRM}
                                                disabled={false}
                                            />
                                        </div>
                                        <InputNumber pt={pt} value={valueCRM} size={1} min={0} max={opereacionCRM ? 100 : compania?.CantidadUsuariosCRM ?? 0} onValueChange={(e) => {
                                            if(!opereacionCRM && compania?.CantidadUsuariosCRM - e.value <= 0 && compania?.LicenciaActivaCRM){
                                                Warning({message: 'La cantidad de licencias no puede ser 0, si desea eliminar la subscripción para este servicio, marque la opcion cancelar Citrus CRM.'})
                                                setValueCRM(0)
                                            }else {
                                                setValueCRM(e.value)
                                                let cantLicencias = opereacionCRM ? (compania?.CantidadUsuariosCRM ?? 0)  + e.value : (compania?.CantidadUsuariosCRM ?? 0)  - e.value
                                                setLicenciasCRM(cantLicencias)
                                                setNewConfig({
                                                    ...newConfig,
                                                    licencasCRM: cantLicencias
                                                })
                                            }
                                        }} showButtons style={{ width: '3rem' }}
                                                     decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
                                    </div>
                                    <h4>Total de Licencias: {licencasCRM} </h4>
                                </>
                            ) : (
                                <>
                                    <h4>{compania?.CantidadUsuariosCRM ?? 0}</h4>
                                </>
                            )}
                        </div>
                    </div>

                    <Row className='d-flex justify-content-start '>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Modulos Adicionales</h4>
                            <SelectButton
                                pt={{
                                    button: {style: {width: '130px',border: `1px solid ${theme.color1}`, color:theme.color1,padding: '0.75rem 0.75rem'}},
                                    label: {style: {fontSize: '15px'}}
                                }}
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        _UsaNomina: e.value.some((item) => item === 1),
                                        _UsaConsulta: e.value.some((item) => item === 2),
                                        _UsaFactoring: e.value.some((item) => item === 3),
                                        _usaRestaurante: e.value.some((item) => item === 4),
                                        _usaPrestamo: e.value.some((item) => item === 5)
                                    })
                                    if(e.value.some((item) => item !== 4)){
                                        setCantidadDispositovsPosRestaurante([])
                                    }
                                    setModulosAdicionales(e.value)
                                    setNewConfig({
                                        ...newConfig,
                                        modulosAdicionales: e.value,
                                        CantidadDispositivosPosRestaurante: []
                                    })
                                }}
                                className="d-flex"
                                id="int-modulosAdi"
                                disabled={!editar}
                                value={modulosAdicionales}
                                options={modulosAdi}
                                optionLabel="name"
                                multiple
                            />
                        </Col>

                        {modulosAdicionales.find((item) => item === 4) && (
                            <>
                                <Col className='d-flex flex-column align-items-center mb-3'>
                                    <h4 className='text-muted text-center'>Dispositivos Adicionales</h4>
                                    <SelectButton
                                        pt={{
                                            button: { style: { width: '150px', border: `1px solid ${theme.color1}`, color: theme.color1, padding: '0.75rem 0.75rem' } },
                                            label: { style: { fontSize: '15px' } }
                                        }}
                                        className="d-flex"
                                        disabled={!editar}
                                        value={cantidadDispositivosPosRestaurante[0]}
                                        onChange={(e) => {
                                            setCompania({
                                                ...compania,
                                                CantidadDispositivosPosRestaurante: e.value
                                            })
                                            setNewConfig({
                                                ...newConfig,
                                                CantidadDispositivosPosRestaurante: [e.value]
                                            })
                                            setCantidadDispositovsPosRestaurante([e.value])
                                        }}
                                        options={CantidadTabletasPOSResturante}
                                        optionLabel="name"
                                    />
                                </Col>
                            </>
                        )}

                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Configuracion</h4>
                            <SelectButton
                                pt={{
                                    button: {style: {width: '225px',border: `1px solid ${theme.color1}`, color:theme.color1,padding: '0.75rem 0.75rem'}}
                                }}
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        _UsaCaja: e.value.some((item) => item === 1),
                                        _UsaCentro: e.value.some((item) => item === 2)
                                    })
                                    setConfigAdi(e.value)
                                    setNewConfig({
                                        ...newConfig,
                                        otrasConfig: e.value
                                    })
                                }}
                                className="d-flex"
                                id="int-configuracion"
                                disabled={!editar}
                                value={configAdic}
                                options={otrasConfig}
                                optionLabel="name"
                                multiple
                            />
                        </Col>
                        
                    </Row>

                    <Row className='d-flex justify-content-start'>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Integraciones DGII</h4>
                            <SelectButton
                                pt={{
                                    button: {style: {width: '450px',border: `1px solid ${theme.color1}`, color:theme.color1,padding: '0.75rem 0.75rem', borderRadius: '6px'}}
                                }}
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        _usaFacturacionElectronica: e.value === 1,
                                        _UsaImpresoraFiscal: e.value === 2,
                                        _TipoPlanEcf: e.value === 1 ? "1kT" : null
                                    })
                                    setTipoPlan(e.value === 1 ? ['1kT'] : [])
                                    setIntDGII([e.value])
                                    setNewConfig({
                                        ...newConfig,
                                        intDGII: [e.value],
                                        tipoPlanECF: e.value === 1 ? ['1kT'] : null
                                    })
                                }}
                                className="d-flex"
                                id="int-dgii"
                                disabled={!editar}
                                value={intDGII[0]}
                                options={integracionesDgii}
                                optionLabel="name"
                            />
                        </Col>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Panel de Firma</h4>
                            <SelectButton
                                pt={{
                                    button: {style: {width: '150px',border: `1px solid ${theme.color1}`, color:theme.color1,padding: '0.75rem 0.75rem'}}
                                }}
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        _UsaVisaNet: e.value === 2,
                                        _UsaAzul: e.value === 3,
                                        _UsaCardNet: e.value === 1
                                    })
                                    setPanelFirma([e.value])
                                    setNewConfig({
                                        ...newConfig,
                                        panelFirma: [e.value]
                                    })
                                }}
                                className="d-flex"
                                id="int-panelFirma"
                                disabled={!editar}
                                value={panelFirma[0]}
                                options={integracionesPanelFirma}
                                optionLabel="name"
                            />
                        </Col>
                        {(intDGII[0] === 1) && (
                            <>
                                <Col className='d-flex flex-column align-items-center mb-3'>
                                    <h4 className='text-muted text-center'>Planes</h4>
                                    <Select
                                        isDisabled={!editar}
                                        styles={{container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '450px',
                                                padding: '0px'
                                            })}}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        name="Planes"
                                        onChange={(e) => {
                                            setCompania({
                                                ...compania,
                                                _TipoPlanEcf: e.value
                                            })
                                            setTipoPlan([e.value])
                                            setNewConfig({
                                                ...newConfig,
                                                tipoPlanECF: [e.value]
                                            })
                                        }}
                                        options={planesEcf}
                                        value={
                                            !compania?.TipoPlanECF
                                                ? planesEcf.filter(function (option) {
                                                    return option.value === "1kT";
                                                })
                                                : planesEcf.filter(function (option) {
                                                    return option.value === ( newConfig?.tipoPlanECF[0] || '1kT');
                                                })
                                        }
                                    />
                                </Col>

                                <Col className='d-flex flex-column align-items-center mb-3' style={{opacity: '0'}}>
                                    <h4 className='text-muted text-center'>Planes</h4>
                                    <Select
                                        isDisabled={true}
                                        styles={{container: (baseStyles) => ({
                                                ...baseStyles,
                                                padding: '0 15px'
                                            })}}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        name="Planes"
                                        onChange={(e) => {
                                            setCompania({
                                                ...compania,
                                                _TipoPlanEcf: e.value
                                            })
                                            setTipoPlan([e.value])
                                            setNewConfig({
                                                ...newConfig,
                                                tipoPlanECF: [e.value]
                                            })
                                        }}
                                        options={planesEcf}
                                        value={
                                            !compania?.TipoPlanECF
                                                ? planesEcf.filter(function (option) {
                                                    return option.value === "1kT";
                                                })
                                                : planesEcf.filter(function (option) {
                                                    return option.value === ( newConfig?.tipoPlanECF[0] || '1kT');
                                                })
                                        }
                                    />
                                </Col>
                                
                            </>
                        )}
                    </Row>


                    <Row className='d-flex justify-content-around '>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Comercio Electronico</h4>
                            <SelectButton
                                pt={{
                                    button: {style: {width: '150px',border: `1px solid ${theme.color1}`, color:theme.color1,padding: '0.75rem 0.75rem'}}
                                }}
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        _UsaShopify: e.value.some((item) => item === 2),
                                        _UsaWooCommerce: e.value.some((item) => item === 1),
                                        _UsaMiniHotel: e.value.some((item) => item === 3)
                                    })
                                    setComercioElec(e.value)
                                    setNewConfig({
                                        ...newConfig,
                                        comercioElec: e.value
                                    })
                                }}
                                className="d-flex"
                                id="int-comercioElec"
                                disabled={!editar}
                                value={comercioElec}
                                options={integracionComernioElectronico}
                                optionLabel="name"
                                multiple
                            />
                        </Col>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Enlace de Pago</h4>
                            <SelectButton
                                pt={{
                                    button: {style: { width: '450px', border: `1px solid ${theme.color1}`, color:theme.color1,borderRadius: '6px'}}
                                }}
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        _UsaCardNetEnLinea: e.value === 1
                                    })
                                    setLinkPago([e.value])
                                    setNewConfig({
                                        ...newConfig,
                                        linkPago: [e.value]
                                    })
                                }}
                                className="d-flex"
                                id="int-enlacePago"
                                disabled={!editar}
                                value={linkPago[0]}
                                options={integracionLinkPago}
                                optionLabel="name"
                            />
                        </Col>
                    </Row>

                    <Row className='d-flex justify-content-around '>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Plan de Datos (Uso Actual: {usoDatos})</h4>
                            <SelectButton
                                pt={{
                                    button: {style: { width: '450px', border: `1px solid ${theme.color1}`, color:theme.color1,borderRadius: '6px'}}
                                }}
                                className="d-flex"
                                id="int-totalUsoDatos"
                                disabled={true}
                                value={1}
                                options={USO_DATOS}
                                optionLabel="name"
                            />
                        </Col>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Cancelar Servicio</h4>
                            <SelectButton
                                pt={{
                                    button: {style: {width: '225px',border: `1px solid ${theme.color1}`, color:theme.color1,padding: '0.75rem 0.75rem'}}
                                }}
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        CancelarERP: e.value.some((item) => item === 1),
                                        CancelarCRM: e.value.some((item) => item === 2),
                                    })
                                    setCancelarServicio(e.value)
                                }}
                                className="d-flex"
                                id="int-dgii"
                                disabled={!editar}
                                value={cancelarServicio}
                                options={CANCELACION_SERVICIO}
                                optionLabel="name"
                                multiple
                            />
                        </Col>
                    </Row>

                    {editar && (
                        <Row className='d-flex justify-content-center'>
                            <div className='d-flex justify-content-between mb-3' style={{maxWidth: '50%', gap: '20px'}}>
                                <Button type="button" style={{height:'auto',backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1}} onClick={() => {
                                    if((compania?.CancelarCRM ?? false) && (compania?.CancelarERP ?? false)){
                                        Confirm({
                                            type: Types.TYPE_DEFAULT,
                                            title: `Cancelacion Citrus ERP y Citrus CRM`,
                                            textBody: `Está seguro que quiere cancelar Citrus ERP y Citrus CRM ?`,
                                            onConfirm: () => { setRazonCancelacionModalVisible(true) },
                                            onCancel: () => {
                                                setCompania({
                                                    ...compania,
                                                    CancelarCRM: false,
                                                    CancelarERP: false,
                                                })
                                            },
                                            confirmBtnText: "Si",
                                            cancelBtnText: "No",
                                        });
                                    } else if((compania?.CancelarCRM ?? false)){
                                        Confirm({
                                            type: Types.TYPE_DEFAULT,
                                            title: `Cancelacion Citrus CRM`,
                                            textBody: `Está seguro que quiere cancelar Citrus CRM ?`,
                                            onConfirm: () => { setRazonCancelacionModalVisible(true) },
                                            onCancel: () => {
                                                setCompania({
                                                    ...compania,
                                                    CancelarCRM: false,
                                                })
                                            },
                                            confirmBtnText: "Si",
                                            cancelBtnText: "No",
                                        });
                                    }else if ((compania?.CancelarERP ?? false)){
                                        Confirm({
                                            type: Types.TYPE_DEFAULT,
                                            title: `Cancelacion Citrus ERP`,
                                            textBody: `Está seguro que quiere cancelar Citrus ERP ?`,
                                            onConfirm: () => { setRazonCancelacionModalVisible(true)},
                                            onCancel: () => {
                                                setCompania({
                                                    ...compania,
                                                    CancelarERP: false,
                                                })
                                            },
                                            confirmBtnText: "Si",
                                            cancelBtnText: "No",
                                        });
                                    }

                                    else if(JSON.stringify(configInicial) === JSON.stringify(newConfig)){
                                        Warning({message: 'Para proceder tiene que realizar al menos un cambio'})
                                    } else {
                                        validarLicencias();
                                    }
                                }} className="btn btn-lg form-control">Aceptar</Button>
                                <Button type="button" style={{height:'auto',backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1}} onClick={() => {
                                    setEditar(false)
                                    setCompania(companiaInicial);
                                }} className="btn btn-lg form-control">Cancelar</Button>
                            </div>
                        </Row>
                    )}
                </Container>
            )}
        </>
    )

}